"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _icon = _interopRequireDefault(require("./icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArrowRightIcon = function ArrowRightIcon(props) {
  var id = props.id,
      className = props.className;
  return _react.default.createElement(_icon.default, {
    id: id ? id : null,
    className: className
  }, _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", {
    id: id ? "".concat(id, "_title") : null
  }, "arrow"), _react.default.createElement("path", {
    d: "M7.2,5.94a1.22,1.22,0,0,0-.36-.87L2.11.36A1.22,1.22,0,0,0,.39,2.09L4.26,5.95l-3.91,4a1.22,1.22,0,1,0,1.74,1.72L6.85,6.8a1.22,1.22,0,0,0,.35-.86Z",
    transform: "translate(6.35 3.8)"
  })));
};

var _default = ArrowRightIcon;
exports.default = _default;